<ng-container *ngIf="(isLoading$ | async) && !(productDetails$ | async)">
    <div class="spinner-screen">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
</ng-container>

<div *ngIf="productDetails$ | async as product">
    <clearcals-store-header [heroContent$]="heroContent$"></clearcals-store-header>

    <div class="product-detail" [class.padding-top]="!(heroContent$ | async)">
        <div class="container">
            <!-- mobile image carousel -->
            <ngx-slick-carousel class="carousel" #slickModal [config]="slideConfig">
                <div ngxSlickItem *ngFor="let image of product.images.edges">
                    <img [src]="image.node.url"
                        [alt]="image.node.altText || extractImageAlt(image.node.url)" />
                </div>
            </ngx-slick-carousel>

            <!-- Left Column: Images -->
            <div class="thumbnails">
                <img *ngFor="let image of product.images.edges" height="80" width="80"
                    [src]="image.node.url" [alt]="image.node.altText || extractImageAlt(image.node.url)"
                    (click)="changeImage(image)"
                    [class.selected]="image.node.url === ((selectedImage$ | async).node.url)" />
            </div>
            <div class="image-section">
                <div class="main-image">
                    <img [src]="(selectedImage$ | async).node.url"
                        [alt]="(selectedImage$ | async).node.altText || extractImageAlt((selectedImage$ | async).node.url)" />
                </div>
            </div>

            <!-- Right Column: Details -->
            <div class="details-section">
                <ng-container *ngIf="selectedVariant$ | async as selectedVariant">
                    <div>
                        <h1>{{ product.title }}</h1>
                        <p class="description">{{ selectedVariant.node.title }}</p>
                    </div>
                    <div class="pricing">
                        <div *ngIf="selectedVariant.node.compareAtPrice.amount > selectedVariant.node.price.amount"
                            class="original">
                            <span class="original-price">₹ {{ selectedVariant.node.compareAtPrice.amount |
                                number:'1.0-0' }}</span>
                            <span class="savings">Save ₹ {{ selectedVariant.node.compareAtPrice.amount -
                                selectedVariant.node.price.amount | number:'1.0-0' }}</span>
                        </div>
                        <span class="discounted-price">₹ {{ selectedVariant.node.price.amount | number:'1.0-0'
                            }}</span>
                    </div>
                </ng-container>
                <div class="offer" *ngIf="hintPremiumOffer$ | async as hintPremiumOffer">{{ hintPremiumOffer }}</div>
                <div class="info" *ngIf="shippingInfo$ | async as shippingInfo">{{ shippingInfo }}</div>
                <button (click)="clickBuyNow" *ngIf="selectedVariant$ | async as selectedVariant"
                    (click)="checkout(selectedVariant)" class="buy-now">
                    <span>Buy Now</span>
                    <span *ngIf="isLoading$ | async" class="spinner">
                        <mat-spinner diameter="20"></mat-spinner>
                    </span>
                </button>

                <!-- The widget will render here -->
                <div id="razorpay-affordability-widget"></div>

                <div class="info">
                    Need help or have a question?<br>
                    <a class="offer"
                        [href]="'https://wa.me/+918886667634?text=Hi,%20I%20am%20interested%20in%20' + product.title"
                        target="_blank">
                        Chat with us on WhatsApp
                        <ic-icon [icon]="whatsappIcon" style="vertical-align: middle;"></ic-icon>
                    </a>
                </div>
                <div class="model-title">Model/Colour</div>
                <div class="models">
                    <div *ngFor="let variant of product.variants.edges" class="overlay-container"
                        (click)="selectVariant(variant)"
                        [class.selected]="variant.node.image.url === (selectedVariant$ | async).node.image.url">
                        <img loading="lazy" [src]="variant.node.image.url"
                            [alt]="extractImageAlt(variant.node.image.url)" />
                        <div *ngIf="variant.node.image.url !== (selectedVariant$ | async).node.image.url"
                            class="overlay">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- features -->
    <div class="features" *ngIf="features$ | async as features">
        <div *ngFor="let it of features">
            <div class="feature-image-container" *ngIf="it.header as image">
                <img loading="lazy" class="feature-desktop-image" [src]="image.desktop_src"
                    [alt]="extractImageAlt(image.desktop_src)">
                <img loading="lazy" class="feature-mobile-image" [src]="image.mobile_src"
                    [alt]="extractImageAlt(image.mobile_src)">
            </div>
            <div class="collection-container" *ngIf="it.collection">
                <div class="collection-card" *ngFor="let item of it.collection.items">
                    <img loading="lazy" height="200" width="200" [src]="item.imageUrl"
                        [alt]="extractImageAlt(item.imageUrl)" />
                    <div class="collection-text">
                        <h2 class="title"> {{item.title}} </h2> 
                        <h3 class="description">{{item.description}}</h3>
                    </div>
                </div>
            </div>
            <ngx-slick-carousel *ngIf="it.collection" class="collection-container-mobile" #collectionSlickModal
                [config]="slideConfig">
                <div ngxSlickItem class="collection-card" *ngFor="let item of it.collection.items">
                    <img loading="lazy" height="200" width="200" [src]="item.imageUrl"
                        [alt]="extractImageAlt(item.imageUrl)" />
                    <div class="collection-text">
                        <h2 class="title"> {{item.title}} </h2> 
                        <h3 class="description">{{item.description}}</h3>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</div>